<template>
    <list-items-styled :isArticle="isArticle">
        <st-divider>
            <slot />
        </st-divider>

        <div v-if="loading" class="items-loading">
            <st-loading :visible="loading" />
        </div>

        <div v-if="isLast && !loading && (!isNoneSubscribe || isRouteSchool)" class="is-last">
            <awesome-icon name="minus-circle" />
            <div>추가 게시물이 없습니다.</div>
        </div>

        <div v-if="isNoneSubscribe && !loading && !isLast" class="is-none-subscribe">
            <st-divider :between="1.6"><span>구독</span>중인 학교가 없습니다.</st-divider>
            <st-divider class="description" :between="1.6">
                상단의 학교 검색을 통해 자녀분의 학교를 <span>구독</span>해보세요.
            </st-divider>
            <div><awesome-icon name="school" /> <awesome-icon name="heart" /></div>
        </div>
    </list-items-styled>
</template>

<script>
import styled, { css } from "vue-styled-components";

const props = {
    isArticle: Boolean
};

const ListItemsStyled = styled("div", props)`
    max-width: 724px;

    ${props =>
        props.isArticle &&
        css`
            margin: 0 auto;
        `}

    .is-last {
        padding: 60px 0;
        text-align: center;
        color: #b9b9b9;
        font-size: 1.8rem;

        svg {
            margin-bottom: 1.6rem;
            font-size: 3.2rem;
        }
    }

    .is-none-subscribe {
        padding-top: 10rem;
        text-align: center;
        color: ${props => props.theme.color.disabled};
        font-size: 2.4rem;

        span {
            color: ${props => props.theme.color.primary};
        }

        .description {
            font-size: 1.6rem;
        }

        svg {
        }
    }
`;

export default {
    name: "ListItems",
    props: {
        ...props,
        loading: Boolean,
        isLast: Boolean
    },
    computed: {
        isNoneSubscribe() {
            return this.$store.state.notice.isNoneSubscribe;
        },

        isNoneNotice() {
            // 추가 게시물이 없어야하고, 로딩이 끝나야하고, 구독학교가 있거나 학교페이지 여야 보임.
            return this.isLast && !this.loading && (!this.isNoneSubscribe || this.isRouteSchool);
        },

        isRouteSchool() {
            return this.$route.name.toLowerCase() === "school";
        }
    },
    components: {
        ListItemsStyled
    }
};
</script>
